import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MuiCard from "../../../../components/Card/Card";
import { useParams } from "react-router-dom";
import useFetch from "use-http";
import StudentDetails from "./StudentsDetails";
import StudentInfoCard from "./StudentInfoCard";
import { Grid } from "@mui/material";
import ParentsTable from "./ParentsTable";
import EnrollmentTable from "./EnrollmentTable";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TabDetails = ({ student }): any => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Detalhes" {...a11yProps(0)} />
          <Tab label="Aulas" {...a11yProps(1)} />
          <Tab label="Boletim" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Box>
          <Grid container>
            <Grid item xs={4} mr={8}>
              <StudentInfoCard student={student} />
            </Grid>
            <Grid item xs={7}>
              <ParentsTable student={student} />
              <Box height={12} />
              <EnrollmentTable />
            </Grid>
          </Grid>
        </Box>
      </TabPanel>
      <TabPanel value={value} index={1}></TabPanel>
      <TabPanel value={value} index={2}></TabPanel>
    </Box>
  );
};

export default TabDetails;
